import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

/*
  NdoeSpinner — le rond qui tourne, en une ligne, sans @mui/material.

  POURQUOI CE COMPOSANT EXISTE
  27 endroits affichaient <CircularProgress size={N} /> de @mui/material. C'était
  la SEULE chose que ce dépôt importait jamais de MUI : 25 fichiers, 25 imports,
  25 fois CircularProgress et rien d'autre. Une bibliothèque d'interface entière
  (@mui/material, plus @emotion son moteur CSS) embarquée pour un rond qui tourne
  — téléchargée par chaque livreur, en 3G, à Kinshasa.

  Le projet a déjà tout ce qu'il faut : antd est là de toute façon (des centaines
  de composants en dépendent), et @ant-design/icons aussi.

  CHOIX DE SIGNATURE : `size` en PIXELS, comme MUI, et non les tailles nommées
  d'antd (small/default/large). C'est ce qui rend la substitution mécanique et
  sûre — les 27 appels passaient exactement size={16|24|28|30}, jamais de couleur
  ni de style. Une conversion vers 3 tailles nommées aurait fait bouger des
  pixels sur 27 écrans sans que personne l'ait demandé.

  La couleur suit --ndoe-ink, le jeton de la charte, au lieu du bleu MUI par
  défaut qui n'appartenait à rien.
*/
export default function NdoeSpinner({ size = 28, className, style }) {
  return (
    <Spin
      className={className}
      style={style}
      indicator={
        <LoadingOutlined
          style={{ fontSize: size, color: 'var(--ndoe-ink, #071c3d)' }}
          spin
        />
      }
    />
  );
}
